import React, { useEffect } from 'react';
import Style from '../Styles/ShoppingCartPaperStyle';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ShoppingCartItem from '../../ShoppingCartItem/ShoppingCartItem'
import LoadingComponent from '../../LoadingComponent/LoadingComponent'
import {
    Link
  } from "react-router-dom";

export default function ShoppingCartPaper(props) {
  const classes = Style();
  useEffect(() => {
    props.componentMethods.getShoppingCartItemsAction()
    }, []);
    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }

    const componentProps = {
        ...props.componentProps
    }
    let shoppingCartTotal = 0;
    const shoppingCartItems = componentMethods.getManagerState().shoppingCartItems
    for(let i in shoppingCartItems) {
        shoppingCartTotal += shoppingCartItems[i].shoppingCartItemsQuantity * shoppingCartItems[i].shopProductsListPriceConverted / 100
    }
    shoppingCartTotal = shoppingCartTotal.toFixed(2)
  return (<div style={classes.root}>
      <Typography variant="h5" component="h5" style={classes.title}>
            {componentConstants.language.LANG_SHOPPING_CART}
        </Typography>
        {
        props.componentMethods.getManagerState().loadingShoppingCartItems ?
            <LoadingComponent />
            : 
            null
        }
    {
        componentMethods.getManagerState().shoppingCartItems.map((el, idx) => {
            return <ShoppingCartItem key={idx} element={el} componentMethods={componentMethods}  componentConstants={componentConstants} componentProps={componentProps} />
        })
    }
     {
        props.componentMethods.getManagerState().loadingShoppingCartItems ?
            null
            : 
            <Typography component="div" variant="h6" gutterBottom>Total: {shoppingCartTotal} {componentConstants.language.LANG_CURRENCY}</Typography>
        }
        <Link to="/checkout" style={classes.proceedToCheckout}>
            <Button variant="contained" color="secondary" fullWidth={true} style={classes.closeButton}>
                {componentConstants.language.LANG_PROCEED_TO_CHECKOUT }
            </Button>
        </Link>
        <Button onClick={componentMethods.handleClosePopover} variant="outlined" color="secondary" fullWidth={true} style={classes.closeButton}>
            {componentConstants.language.LANG_CLOSE}
        </Button>
  </div>);
}